<template>
  <v-app>
    <v-main>
      <booking-widget></booking-widget>
    </v-main>
  </v-app>
</template>

<script>
import BookingWidget from '@/components/BookingWidget'

export default {
  name: `App`,

  components: {
    BookingWidget,
  },

  data: () => ({

  }),

  methods: {
  },
};
</script>
